import React, {useRef, useEffect} from 'react';

import {Loader} from '@googlemaps/js-api-loader';

import {getClientConfig} from 'ultra/configs/general';

import Skeleton from '@mui/material/Skeleton';

import './index.scss'

export default function LocationWidget(props) {
    const {location, showSkeleton} = props;

    const {firebase} = getClientConfig(window);

    const mapRef = useRef(null);

    useEffect(() => {
        const loader = new Loader({
            apiKey: firebase.apiKey,
            version: "weekly",
            libraries: ["places", "marker"]
        });

        loader.load()
            .then(google => {
                const map = new google.maps.Map(mapRef.current, {
                    mapId: firebase.mapId,
                    center: {
                        lat: Number(location.lat),
                        lng: Number(location.lng)
                    },
                    zoom: 18,
                    disableDefaultUI: true,
                });

                // const marker = 
                new google.maps.marker.AdvancedMarkerElement({
                    map,
                    position: {
                        lat: Number(location.lat),
                        lng: Number(location.lng)
                    }
                });
            })
            .catch(error => {
                console.error("Error loading Google Maps API", error);
            });
    }, []);

    if (showSkeleton) {
        return <div className='LocationWidget'>
            <Skeleton variant="rectangular" width="100%" height={200} />
        </div>
    }

    return <div className='LocationWidget'>
      {location.lat && location.lng && <div className='LocationWidgetMap'>
        <div className='Map' ref={mapRef} style={{height: '300px', width: '100%'}} />
      </div>}

      {location.link && <div className='labelWrap Link'>
        <span className="label">Google Maps:</span>
        <span className="labelValue">
            <a href={location.link} target='_blank'>{location.title || location.link}</a>
        </span>
      </div>}
    </div>
}
